// Public landing page shown after an external (hauler) driver sets their password
// via Auth0 and is redirected to /mobile. See DEV-3191.

// Published store listings for the TruckTrax Geo / "TruckTrax Geo" mobile app.
export const APP_STORE_URL = 'https://apps.apple.com/us/app/trucktrax-geo/id6575346635';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.trucktrax.geotrax';

// Custom URL scheme + Android package registered by the published app (v3 trax-mobile,
// Capacitor). Tapping a `com.trucktrax.geotrax://…` link opens the app if installed.
// NOTE: this is a custom scheme, NOT a Universal/App Link, so it does NOT fall back to the
// store on its own. Android uses an `intent://` launcher with a Play Store fallback; iOS intentionally does not auto-fallback (the App Store link is primary).
export const APP_DEEP_LINK_SCHEME = 'com.trucktrax.geotrax';
export const ANDROID_PACKAGE_NAME = 'com.trucktrax.geotrax';

// No in-app route — we just open the app and let v3 (trax-mobile) route from its root. Its
// appUrlOpen handler navigates to `/<path>`, so an empty path lands on `/`, whose auth guard
// sends the driver to the right screen (login if needed). Avoids coupling to v3 route names.
export const APP_DEEP_LINK_PATH = '';

export const MOBILE_LANDING_TITLE = 'Welcome to TruckTrax Geo!';

export const MOBILE_LANDING_PARAGRAPHS = [
  'TruckTrax Geo is an app created specifically for haulers and their drivers who support our fleet.',
  'TruckTrax Geo only shares location information with our team when a driver has driven into a supplying plant or terminal AND is actively hauling for the business with an assigned ticket.',
  'Using TruckTrax Geo helps by providing automatic status updates and ticket management, thus improving accuracy.',
];

export const GET_THE_APP_TEXT = 'Get the TruckTrax Geo app';
export const OPEN_APP_TEXT = 'Open TruckTrax Geo';
export const APP_STORE_BUTTON_TEXT = 'Download on the App Store';
export const PLAY_STORE_BUTTON_TEXT = 'Get it on Google Play';
